"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var l = require("lenovo");
var searchCommon = require("../../../core/src/product_selector/ps.search.common");
var lsb = require("../../../core/src/product_selector/ps.lsb");
var browse = require("../../../core/src/product_selector/ps.browse.dropdown");
var myproducts = require("../../../core/src/product_selector/micro.myproducts");
var lenovo_1 = require("lenovo");
$('.thisCapsModal').each(function () {
    if (!$(this).attr('complete')) {
        var $this = $(this);
        searchCommon.load($this.find('#caps-search').get(0), lenovo_1.SearchComponentType.CapsFull, l.DTM.Lmd.linkTrackTypeValue(lenovo_1.LinkTrackType.CapsSearchProduct));
        myproducts.load($this.find('#caps-products').get(0));
        lsb.load($this.find('#caps-serial').get(0), lenovo_1.SearchComponentType.CapsSn, l.DTM.Lmd.linkTrackTypeValue(lenovo_1.LinkTrackType.CapsSerialNumber));
        $this.find(".browse-product a").on('click', function () {
            $this.find('.modal-body.main-body').fadeOut(50, function () {
                $this.find(".back-to-main").show();
                $this.find('#caps-browse').show();
                var tabName = $this.attr('tabname') ? l.UrlUtility.getPSPTabs($this.attr('tabname')) : "";
                var tabSubUrl = $this.attr('suburl') || "";
                browse.load($this.find('#caps-browse').get(0), lenovo_1.BrowseComponentType.Caps, tabName, tabSubUrl);
            });
        });
        $this.find(".back-to-main").on('click', function () {
            $this.find('#caps-browse').fadeOut(50, function () {
                $this.find(".back-to-main").hide();
                $this.find('.modal-body.main-body').fadeIn(50);
            });
        });
        $this.find('.motoLogin').on('click', function () {
            window.location.href = l.AccountAuthentication.getPassportLenovoUrl('MotoLoginUrl');
        });
        $this.attr('complete', 'yes');
    }
});
if (window["capssearch"] && typeof window["capssearch"] == "function") {
    //configed in sitecore
    window["capssearch"](this);
}
window["ConfirmCurrentProduct"] = function (data, callback, $element) {
    var $capsModal = $element.parents('.thisCapsModal');
    if (l.Common.getProductId().toLowerCase() !== data[0].Id.toLowerCase()) {
        var $capsConfirm = $capsModal.find(".caps-confirm");
        var content = "<p><label>" + l.Translator.translate('This serial number is for a') + "</label>&nbsp;" +
            "<label>" + data[0].Name + "&nbsp;/&nbsp;" + data[0].Serial + "</label></p>" +
            "<p><label>" + l.Translator.translate('would you like to go to this sub product instead') + "</label></p>";
        $capsConfirm.find('.caps-confirm-content').empty().append(content);
        $capsConfirm.show();
        $capsConfirm.find('.caps-confirmYes').off('click').on('click', function () {
            callback();
        });
        $capsConfirm.find('.caps-confirmNo').off('click').on('click', function () {
            $capsConfirm.hide();
        });
    }
    else {
        callback();
    }
};
$(function () {
    var removeheadandfoot = function () {
        var headercount = $("#mse_litepage_caps header").length;
        var footercount = $("#mse_litepage_caps header").length;
        if (headercount > 0) {
            $("#mse_litepage_caps header").remove();
        }
        if (headercount > 0) {
            $("#mse_litepage_caps footer").remove();
        }
    };
});
